import { render, staticRenderFns } from "./TextAreaWithLable.vue?vue&type=template&id=efe92fbc&scoped=true&"
import script from "./TextAreaWithLable.vue?vue&type=script&lang=js&"
export * from "./TextAreaWithLable.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaWithLable.vue?vue&type=style&index=0&id=efe92fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe92fbc",
  null
  
)

export default component.exports